<template>
  <div class="postavitev-info">
    <div class="info-okvir">
      <div class="postavitev-info-icone">
        <i class="fa fa-info-circle"></i>
      </div>
      <div class="postavitev-info-tekst" v-if="kontaktniPodatki !== null">
        <p class="modra-barva-info">
          <b>
            V primeru, da paketa ni možno spremeniti, preverite status aktivnih ugodnosti na vašem
            priključku.
          </b>
          <span v-if="kontaktniPodatki !== null">
              Za več informacij nas lahko pokličete na {{ kontaktniPodatki.T2_SUPPORT_TEL_ST }}.
          </span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import {KontaktniPodatkiEnum} from '../../../../../assets/js/Enum/KontaktniPodatkiEnum.js'

export default {
  name: 'InfoKomponenta',
  data () {
    return {
      kontaktniPodatki: null
    }
  },
  mounted () {
    this.kontaktniPodatki = KontaktniPodatkiEnum
  }
}
</script>
<style scoped>
.info-okvir {
  width: 580px;
  height: 95px;
  display: flex;
}

@media only screen and (max-width: 1430px) {
  .info-okvir {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Naroci/NarociTrzniPaketi/InfoKomponenta.vue